import { faCheck, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from '../_helpers/withRouter';
import { useNavigate } from 'react-router-dom';
import {
    Breadcrumb, BreadcrumbItem, Button, ButtonDropdown, Card, CardBody, CardHeader, Col,
    Container, Form, FormGroup, Input, Label, Row
} from 'reactstrap';
import Swal from 'sweetalert2';
import { authActions, empresaAction, usuarioAction } from '../_actions';
import NavBar from '../_components/navbar';
import { stringUtils } from '../_utils'
import { uploadFile } from '../_services'

const EmpresaEdit = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [id, setId] = useState(0);

    const [isOpenDrop, setOpenDrop] = useState(false);
    const toggleDropDown = () => setOpenDrop(!isOpenDrop);
    const [logo, setLogo] = useState('');
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (logo && logo != undefined && logo != null) {
            setOpen(true)
            upload('caminho_logo', logo)
        }
    }, [logo])

    const handleChangeFile = (e) => {
        setLogo(e.target.files[0])
    }

    function getNameFile() {
        const url = props.empresa.caminho_logo.toString();
        const fileName = url.split('/').pop();
        return fileName;
    }

    const upload = (prop, fileUpload) => {
        uploadFile(fileUpload)
            .then((response) => {
                setTimeout(function () {
                    var event2 = {
                        type: 'select',
                        target: {
                            value: response.toString()
                        }
                    };
                    dispatch(empresaAction.onChangeProps(prop, event2))
                    setOpen(false)

                }, 1000);

            })
            .catch((err) => {
                console.log(err)
                setOpen(false)
            })
    }

    useEffect(() => {
        const { match: { params } } = props;

        dispatch(usuarioAction.getSelectInseminadores());

        if (params.id) {
            dispatch(empresaAction.getEmpresaById(params.id, true));
            setId(params.id);
        } else {
            if (authActions.isGestor() == false) {
                navigate('/empresas/');
            }
        }
    }, [navigate]);

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(empresaAction.onChangeProps(prop, event));

    };


    const handleValidation = event => {

        var valid = true;
        var errors = '';

        if (props.empresa.nome === null || props.empresa.nome === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um nome válido!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }
        return valid;
    };

    const handleSubmit = event => {


        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                nome: props.empresa.nome,
                estoque_integrado: props.empresa.estoque_integrado,
                caminho_logo: props.empresa.caminho_logo
            };

            if (params.id) {
                dispatch(empresaAction.editEmpresaInfo(params.id, payload, true));

            } else {
                dispatch(empresaAction.createEmpresa(payload, true));
            }
        }

    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/empresas">Lista de Empresas</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Empresa {props.empresa.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4} lg={4}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            id="nome"
                                            label="Nome"
                                            className="form-control"
                                            value={props.empresa.nome}
                                            onInput={stringUtils.toInputUppercase}
                                            onChange={handleChange('nome')} />
                                    </FormGroup>
                                </Col>
                                <Col md={3} lg={3}>
                                    <FormGroup>
                                        <Label className="left" for="estoque_integrado">Estoque integrado</Label>
                                        <Input
                                            id="estoque_integrado"
                                            label="Estoque integrado"
                                            type="checkbox"
                                            checked={props.empresa.estoque_integrado || false}
                                            onChange={handleChange('estoque_integrado')}
                                            style={{ justifyContent: 'left', alignItems: 'left', flex: 1, display: 'flex', marginLeft: '3px' }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={5} lg={5}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Logo</Label>
                                        <Input
                                            id="logo"
                                            accept="image/*"
                                            label="Logo"
                                            onChange={e => handleChangeFile(e)}
                                            type="file"
                                        />
                                    </FormGroup>
                                    {props.empresa.caminho_logo ? (
                                        <tooltip title="Abrir imagem em nova aba">
                                            <span style={{ justifyContent: 'start' }}>Logo atual:&nbsp;</span>
                                            <a
                                                style={{ justifyContent: 'start' }}
                                                href={props.empresa.caminho_logo} // URL válida
                                                target="_blank" // Abre em uma nova aba
                                                rel="noopener noreferrer" // Segurança
                                            >
                                                {getNameFile()}
                                            </a>
                                        </tooltip>
                                    ) : null}
                                </Col>
                            </Row>
                            <hr />
                            <br />
                            <Row>
                                <Col className="left" md="3" lg="3">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex  justify-content-end" lg="12">
                                    <Button className="mr-1" variant="contained" color="secondary" component='a' href="/empresas">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                    <Button variant="contained" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    {id > 0 &&
                                        <ButtonDropdown className="mr-1" isOpen={isOpenDrop} toggle={toggleDropDown}>
                                        </ButtonDropdown>
                                    }
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );
}


const mapStateToProps = (state) => {
    return state;
}

const connectedEmpresaEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(EmpresaEdit));

export { connectedEmpresaEditPage as EmpresaEdit };
